import { all } from 'redux-saga/effects'
import { watcherUser } from 'store/sagas/user'
import { watcherAuth } from 'store/sagas/auth'
import { watcherGoal } from 'store/sagas/goal'
import { watcherPlay } from 'store/sagas/play'
import { watcherForm } from 'store/sagas/form'
import { watcherError } from 'store/sagas/error'
import { watcherAdmin } from 'store/sagas/admin'
import { watcherCommon } from 'store/sagas/common'
import { watcherClients } from 'store/sagas/clients'
import { watcherAssessment } from 'store/sagas/owner'
import { watcherCalendar } from 'store/sagas/calendar'
import { watcherPlayBook } from 'store/sagas/playBook'
import { watcherUserManagement } from 'store/sagas/userManagement'
import { watcherManagePlays } from 'store/sagas/managePlays'
import { watcherMonthlyAttestation } from 'store/sagas/monthlyAttestation'
import { watcherAttestationSummary } from 'store/sagas/attestationSummary'
import { watcherBSO } from './bso'

export default function* rootSaga() {
  const sagas = [
    watcherAuth(),
    watcherUser(),
    watcherGoal(),
    watcherForm(),
    watcherPlay(),
    watcherError(),
    watcherAdmin(),
    watcherCommon(),
    watcherClients(),
    watcherCalendar(),
    watcherPlayBook(),
    watcherAssessment(),
    watcherManagePlays(),
    watcherUserManagement(),
    watcherMonthlyAttestation(),
    watcherAttestationSummary(),
    watcherBSO(),
  ]
  yield all(sagas)
}
